import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Heartbeat,
  NotePencil,
  ChartLineUp,
  Bandaids,
  Gauge,
  Compass,
  ShieldCheck,
  ClipboardText,
} from "@phosphor-icons/react";

import { saveScrollPosition } from "../../useScrollRestore";

/**
 * ProfileLinksGrid — компакт-грид разделов (W-REBUILD-4, мандат раздел 6.4).
 *
 * Профиль = identity-хаб: данные сверху, а всё, что раньше было «80%
 * ссылок» гигантскими карточками с описаниями (4 секции × 2-5 карточек,
 * ~1500px скролла), сжато в один грид 2×N: иконка + короткая метка.
 * Описания живут на целевых страницах.
 */

/**
 * v212 — грид сжат до «я и мои данные»: wellness, дневник, прогнозы,
 * травмы, тесты, анкета, онбординг, приватность. Экипировка, знания,
 * устройства, аватар и приглашение живут в хабе «Ещё» под своими
 * группами — профиль дублировал их вторым списком, и одна и та же
 * навигация жила в двух местах (2026-07-28 эти экраны были сиротами,
 * теперь у каждого есть вход в «Ещё»).
 */
const LINKS: { to: string; key: string; icon: typeof Heartbeat; testId: string }[] = [
  { to: "/wellness", key: "links.wellness", icon: Heartbeat, testId: "grid-wellness" },
  { to: "/diary", key: "links.diary", icon: NotePencil, testId: "grid-diary" },
  { to: "/profile/predictions", key: "links.predictions", icon: ChartLineUp, testId: "grid-predictions" },
  { to: "/injuries", key: "links.injuries", icon: Bandaids, testId: "grid-injuries" },
  { to: "/threshold-test", key: "links.threshold_tests", icon: Gauge, testId: "grid-threshold" },
  { to: "/questionnaire", key: "links.questionnaire", icon: ClipboardText, testId: "grid-questionnaire" },
  { to: "/onboarding/hub", key: "links.onboarding", icon: Compass, testId: "grid-onboarding" },
  { to: "/privacy-dashboard", key: "links.privacy", icon: ShieldCheck, testId: "grid-privacy" },
];

export function ProfileLinksGrid() {
  const nav = useNavigate();
  const { t } = useTranslation("profile");
  return (
    <div data-testid="profile-links-grid" className="grid grid-cols-2 gap-2">
      {LINKS.map(({ to, key, icon: Icon, testId }) => (
        <button
          key={to}
          type="button"
          data-testid={testId}
          onClick={() => {
            saveScrollPosition("scroll:profile");
            nav(to);
          }}
          className="indigo-card px-3 py-2.5 flex items-center gap-2.5 text-left hover:bg-bg-raised transition-colors"
        >
          <Icon size={15} className="text-fg-secondary shrink-0" aria-hidden />
          <span className="text-[12.5px] font-medium text-fg-primary truncate">
            {t(key)}
          </span>
        </button>
      ))}
    </div>
  );
}
